export enum MutationTypes {
  SET_USER = 'SET_USER',
  SET_ROLE = 'SET_ROLE',
  SET_TOKEN = 'SET_TOKEN',
}
